
import Vue from 'vue'
import Chart from 'chart.js'

export default Vue.extend({
  name: 'LineChart',
  props: {
    labels: { type: Array as () => string[], default: () => [] },
    values: { type: Array as () => number[], default: () => [] },
    color: { type: String, default: '#5b6af0' }
  },
  data: () => ({
    chart: null as any
  }),
  watch: {
    values () {
      this.render()
    },
    labels () {
      this.render()
    }
  },
  mounted () {
    this.render()
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  },
  methods: {
    render () {
      const canvas = this.$refs.canvas as HTMLCanvasElement
      if (!canvas) return
      const ctx = canvas.getContext('2d')
      if (!ctx) return

      if (this.chart) {
        this.chart.data.labels = this.labels
        this.chart.data.datasets[0].data = this.values
        this.chart.update()
        return
      }

      const gradient = ctx.createLinearGradient(0, 0, 0, 220)
      gradient.addColorStop(0, `${this.color}33`)
      gradient.addColorStop(1, `${this.color}00`)

      this.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.labels,
          datasets: [
            {
              data: this.values,
              borderColor: this.color,
              backgroundColor: gradient,
              fill: true,
              lineTension: 0.35,
              borderWidth: 2,
              pointRadius: 2,
              pointHoverRadius: 5,
              pointBackgroundColor: this.color
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          tooltips: {
            intersect: false,
            mode: 'index',
            backgroundColor: '#1f2937',
            displayColors: false
          },
          scales: {
            xAxes: [
              {
                gridLines: { display: false },
                ticks: { maxRotation: 0, autoSkip: true, maxTicksLimit: 8 }
              }
            ],
            yAxes: [
              {
                ticks: { beginAtZero: true, precision: 0 },
                gridLines: { color: '#eef0f5' }
              }
            ]
          }
        }
      })
    }
  }
})
